import { withRouter, WithRouterProps } from 'app/components/enhancers/with-router';
import * as React from 'react';
import { Favourite } from './favourite';
import { FavouriteInstance } from './favourite-context';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal/case-view-modal';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Draft } from 'app/area/case/draft';
import { CaseViewModalProvider, useCaseViewModal } from 'app/area/case/components/case-view-modal/case-view-modal-context';

interface FavouriteRouteProps {
  location: { query: { report: string; openFilters?: string; editSavedFavourite?: string }};
  params: { favouriteId: string };
}

const CaseWithRouter = withRouter(Case);
const DraftWithRouter = withRouter(Draft);

export function FavouriteRoute(props: FavouriteRouteProps & WithRouterProps) {
  
  const { params, router: { location: { query } } } = props;

  const report = query?.report ?
    parseInt(query.report, 10) :
    undefined;
  
  const favouriteId = params?.favouriteId && parseInt(params.favouriteId, 10);

  const intiallyOpenFilter = Boolean(query?.openFilters);

  const editSavedFavourite = Boolean(query?.editSavedFavourite);

  return (
     <CaseViewModalProvider>
      <FavouriteInstance>
        <Favourite
          editSavedFavourite={editSavedFavourite}
          initiallyOpenFilter={intiallyOpenFilter}
          overrideReport={report}
          favouriteId={favouriteId}
        />
        <Outlet context={{ favouriteId: favouriteId }} />
      </FavouriteInstance>
    </CaseViewModalProvider>
  );
}

export const FavouriteCaseModalContainer = () => {
  const { favouriteId } = useOutletContext<{ favouriteId: number }>();
  const context = useCaseViewModal();
  return (
    <CaseViewModal favouriteId={favouriteId}
     onClosedCallback={context.triggerModalClose}>
      <Outlet />
    </CaseViewModal>
  );
};

export const FavouriteCaseView = () => {
  return (
    <CaseWithRouter />    
  );
};

export const FavouriteCaseDraft = () => {
  return (
    <DraftWithRouter />
  );
};
